
import { FirearmAssignmentLogEntityDecorator } from './firearm-assignment-log.decorator';
import { FirearmAssignmentLog } from './firearm-assignment-log.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmAssignmentLogTypeInfoBase implements CrudTypeInfo<FirearmAssignmentLog, number> {
  name = 'Firearm Assignment Log';
  entityDecorator = new FirearmAssignmentLogEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM_ASSIGNMENT_LOG'];
  editAuthorities = ['WRITE_FIREARM_ASSIGNMENT_LOG'];
  deleteAuthorities = ['WRITE_FIREARM_ASSIGNMENT_LOG'];
  viewAuthorities = ['READ_FIREARM_ASSIGNMENT'];
  
  searchRouteBase = ['/firearmassignmentlog/search'];
  createRouteBase = ['/firearmassignmentlog/create'];
  editRouteBase = ['/firearmassignmentlog/edit'];
  viewRouteBase = ['/firearmassignmentlog/view'];
  
  description(item: FirearmAssignmentLog): string {
    return '' +  item.assetId;
  }
}



